export default __webpack_public_path__ + "fonts/433953841072ae5e02646fea4905d243.woff2";